import { render, staticRenderFns } from "./ValidityStatusBadge.vue?vue&type=template&id=781e8a0e&scoped=true"
import script from "./ValidityStatusBadge.vue?vue&type=script&lang=ts"
export * from "./ValidityStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./ValidityStatusBadge.vue?vue&type=style&index=0&id=781e8a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781e8a0e",
  null
  
)

export default component.exports